/**
 * Verbatim copy of Review AI's integrations/studio-web/review-enums.json
 * integration artifact. The artifact is pinned to Review AI OpenAPI and
 * database CHECK constraints by Review AI tests.
 */
export const REVIEW_BACKEND_ENUMS = {
  lifecycle: ["REQUESTED", "SCOPED", "OPEN", "CONCLUDED", "CANCELLED"],
  lens: ["UNASSIGNED", "ASSIGNED", "CONCLUDED"],
  finding: ["RAISED", "WITHDRAWN"],
  conclusion: ["SATISFIED", "SATISFIED_WITH_FINDINGS", "NOT_SATISFIED"],
  aggregateOutcome: ["APPROVED", "APPROVED_WITH_CONDITIONS", "REJECTED"],
  severity: ["INFORMATIONAL", "LOW", "MEDIUM", "HIGH", "CRITICAL"],
  blockingSeverity: ["NONE", "INFORMATIONAL", "LOW", "MEDIUM", "HIGH", "CRITICAL"],
  criteria: ["DRAFT", "PUBLISHED", "WITHDRAWN"],
} as const;

export const REVIEW_STATE_LABEL: Record<string, string> = {
  REQUESTED: "Requested",
  SCOPED: "Scoped",
  OPEN: "Open",
  CONCLUDED: "Concluded",
  CANCELLED: "Cancelled",
};

export const LENS_STATE_LABEL: Record<string, string> = {
  UNASSIGNED: "Unassigned",
  ASSIGNED: "Assigned",
  CONCLUDED: "Concluded",
};

export const FINDING_STATE_LABEL: Record<string, string> = {
  RAISED: "Raised",
  WITHDRAWN: "Withdrawn",
};

export const SEVERITY_LABEL: Record<string, string> = {
  INFORMATIONAL: "Informational",
  LOW: "Low",
  MEDIUM: "Medium",
  HIGH: "High",
  CRITICAL: "Critical",
};

export const BLOCKING_SEVERITY_LABEL: Record<string, string> = {
  NONE: "Nothing blocks",
  INFORMATIONAL: "Informational",
  LOW: "Low",
  MEDIUM: "Medium",
  HIGH: "High",
  CRITICAL: "Critical",
};

export const CONCLUSION_OUTCOME_LABEL: Record<string, string> = {
  SATISFIED: "Satisfied",
  SATISFIED_WITH_FINDINGS: "Satisfied with findings",
  NOT_SATISFIED: "Not satisfied",
};

export const AGGREGATE_OUTCOME_LABEL: Record<string, string> = {
  APPROVED: "Approved",
  APPROVED_WITH_CONDITIONS: "Approved with conditions",
  REJECTED: "Rejected",
};

export const CRITERIA_STATE_LABEL: Record<string, string> = {
  DRAFT: "Draft",
  PUBLISHED: "Published",
  WITHDRAWN: "Withdrawn",
};

export function stateLabel(value: string, labels: Record<string, string>): string {
  return labels[value] ?? "Unavailable";
}

export function stateTone(value: string): "neutral" | "success" | "warning" | "danger" {
  if (["CONCLUDED", "SATISFIED", "SATISFIED_WITH_FINDINGS", "APPROVED", "APPROVED_WITH_CONDITIONS"].includes(value)) return "success";
  if (["CANCELLED", "NOT_SATISFIED", "REJECTED", "WITHDRAWN"].includes(value)) return "danger";
  if (["REQUESTED", "SCOPED", "UNASSIGNED", "ASSIGNED", "DRAFT"].includes(value)) {
    return "warning";
  }
  return "neutral";
}
